import { ClassModel } from './class';
import { TrainerModel } from './trainer';
import { BookingModel } from './booking';

export type ClassScheduleModelParams = {
  id: number;
  classId: number;
  branchId: number;
  startTime: string | Date;
  endTime: string | Date;
  publishedAt: string | Date | null;
  bookingOpenAt?: string | Date | null;
  cancelledAt: Record<string, any> | null;
  price: number;
  durationMinutes: number;
  capacity: number;
  location: string;
  cancelBefore?: number | null;
  byUserType?: ClassScheduleByUserType;
  branch?: ClassScheduleBranch | null;
  classModel: ClassModel;
  trainerModels: TrainerModel[];
  bookingModels: BookingModel[];
};

export type ClassScheduleBranch = {
  queueLimit: number;
};

export class ClassScheduleModel {
  id: number;
  classId: number;
  branchId: number;
  startTime: Date;
  endTime: Date;
  publishedAt: Date | null;
  bookingOpenAt: Date | null;
  cancelledAt: Record<string, any> | null;
  price: number;
  durationMinutes: number;
  capacity: number;
  location: string;
  cancelBefore?: number | null;
  byUserType?: ClassScheduleByUserType;
  branch?: ClassScheduleBranch | null;
  class: ClassModel;
  trainers: TrainerModel[];
  booking: BookingModel[];

  get bookingCount(): number {
    return this.booking?.length ?? 0;
  }

  constructor({
    id,
    classId,
    branchId,
    startTime,
    endTime,
    publishedAt,
    bookingOpenAt,
    cancelledAt,
    price,
    durationMinutes,
    capacity,
    location,
    cancelBefore,
    byUserType,
    branch,
    classModel,
    trainerModels,
    bookingModels,
  }: ClassScheduleModelParams) {
    this.id = id;
    this.classId = classId;
    this.branchId = branchId;
    this.startTime = new Date(startTime);
    this.endTime = new Date(endTime);
    this.publishedAt = publishedAt ? new Date(publishedAt) : null;
    this.bookingOpenAt = bookingOpenAt ? new Date(bookingOpenAt) : null;
    this.cancelledAt = cancelledAt;
    this.price = price;
    this.durationMinutes = durationMinutes;
    this.capacity = capacity;
    this.location = location;
    this.cancelBefore = cancelBefore;
    this.byUserType = byUserType;
    this.branch = branch;
    this.class = classModel;
    this.trainers = trainerModels;
    this.booking = bookingModels;
  }
}

export type ClassScheduleByUserTypeItem = {
  price: number;
  capacity: number;
  bookingCount: number;
  queueCount: number;
  chargeType?: ChargeType;
};

export enum ChargeType {
  FREE = 'FREE',
  USE_SESSION = 'USE_SESSION',
  CREDIT = 'CREDIT',
}

export type ClassScheduleByUserType = {
  MEMBER?: ClassScheduleByUserTypeItem;
  SESSION?: ClassScheduleByUserTypeItem;
  DROP_IN?: ClassScheduleByUserTypeItem;
};
